import { apiGet, apiPost, apiPatch, apiDelete } from './client';
import type { AutomationRule } from '../types';

export async function getRules(companyId?: string): Promise<AutomationRule[]> {
  const params = companyId ? `?companyId=${companyId}` : '';
  return apiGet<AutomationRule[]>(`/automation-rules${params}`);
}

export async function getRule(id: string): Promise<AutomationRule> {
  return apiGet<AutomationRule>(`/automation-rules/${id}`);
}

export async function createRule(data: {
  name: string;
  triggerType: string;
  conditions: { terms: string[] };
  actions: { department: string; subject: string };
  companyId?: string;
}): Promise<AutomationRule> {
  return apiPost<AutomationRule>('/automation-rules', data);
}

export async function updateRule(id: string, data: Partial<AutomationRule>): Promise<AutomationRule> {
  return apiPatch<AutomationRule>(`/automation-rules/${id}`, data);
}

export async function deleteRule(id: string): Promise<void> {
  return apiDelete<void>(`/automation-rules/${id}`);
}
